<template>
  <div class="stock-ticker">
    <button @click="paused = !paused" class="button is-dark">
      <b-icon :icon="paused ? 'play' : 'pause'"></b-icon>
    </button>
    <marquee-text :paused="paused">
      <div v-html="stocksTickerString" />
    </marquee-text>
  </div>
</template>

<script>
import MarqueeText from 'vue-marquee-text-component'
import axios from 'axios'
export default {
  name: 'StockTicker',
  props: {
    symbolsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    MarqueeText
  },
  data() {
    return {
      symbols: {},
      stocksTickerString: '',
      paused: false
    }
  },
  methods: {
    updateStocksTickerString() {
      let self = this
      let stocksTickerString = ''
      Object.keys(self.symbols).forEach(element => {
        stocksTickerString += `<div style="display: inline; margin-right: 20px;"><strong>${element}</strong> <span>${
          self.symbols[element].p
        }</span> <i style="color: ${
          self.symbols[element].changeDirection == 'up' ? '#60d19d' : '#ee4a41 '
        };" class="mdi mdi-arrow-${
          self.symbols[element].changeDirection
        }-bold"></i><span style="background-color: ${
          self.symbols[element].changeDirection == 'up' ? '#b5f3df' : '#fbe5e5'
        };">(${self.symbols[element].changeSign}${
          self.symbols[element].change
        })</span>  <span style="background-color: ${
          self.symbols[element].changeDirection == 'up' ? '#b5f3df' : '#fbe5e5'
        };">${self.symbols[element].changeSign}${
          self.symbols[element].changePtj
        }%</span></div>`
      })
      self.stocksTickerString = stocksTickerString
    }
  },
  created() {
    let self = this
    const socket = new WebSocket(
      'wss://ws.finnhub.io?token=btk45qn48v6sr65v4v5g'
    )

    self.symbolsList.forEach(element => {
      axios
        .get(
          `https://finnhub.io/api/v1/quote?symbol=${element}&token=btk45qn48v6sr65v4v5g`
        )
        .then(response => {
          self.symbols[element] = {
            p: response.data.c,
            pc: response.data.pc,
            change: (response.data.c - response.data.pc).toFixed(4),
            changeSign: (response.data.c - response.data.pc > 0 && '+') || '',
            changeDirection:
              (response.data.c - response.data.pc > 0 && 'up') ||
              (response.data.c - response.data.pc < 0 && 'down') ||
              'equal',
            changePtj: (
              (100 * (response.data.c - response.data.pc)) /
              response.data.pc
            ).toFixed(2)
          }
        })
      console.log(self.symbols)
      socket.addEventListener('open', function() {
        self.symbolsList.forEach(element => {
          socket.send(JSON.stringify({ type: 'subscribe', symbol: element }))
        })
      })
    })

    socket.addEventListener('message', function(event) {
      const data = JSON.parse(event.data)
      data.data &&
        data.data.forEach(element => {
          self.symbols[element.s].changePtj = (
            (100 * (element.p - self.symbols[element.s].pc)) /
            self.symbols[element.s].pc
          ).toFixed(2)
          self.symbols[element.s].change = (
            element.p - self.symbols[element.s].pc
          ).toFixed(2)
          self.symbols[element.s].p = element.p
          self.symbols[element.s].changeDirection =
            (element.p - self.symbols[element.s].pc > 0 && 'up') ||
            (element.p - self.symbols[element.s].pc < 0 && 'down') ||
            'equal'
          self.symbols[element.s].changeSign =
            (element.p - self.symbols[element.s].pc > 0 && '+') || ''
        })
      self.updateStocksTickerString()
    })

    var unsubscribe = function(symbol) {
      socket.send(JSON.stringify({ type: 'unsubscribe', symbol: symbol }))
    }
  }
}
</script>

<style scoped>
.stock-ticker {
  position: absolute;
  bottom: 0;
  display: flex;
  background: white;
  box-shadow: 0 -4px 10px #00000022;
}  
</style>
